export default {
    URL: process.env.REACT_APP_PRODUCTION_MODE ? '' : 'http://127.0.0.1:8080',
}
